import { PaymentStatusModal } from "../Billing/partials/PaymentStatusModal";

export const PaymentSuccess = () => {
  return <PaymentStatusModal />;
};

export default PaymentSuccess;
